module.exports = __webpack_public_path__ + "static/media/Journey 01.af5c3a30.png";